import { Component, OnInit, Input } from '@angular/core';
import { AppService } from '../../../app.service';

@Component({
  selector: 'si-dashboard-refresh-timer',
  templateUrl: './dashboard-refresh-timer.component.html',
  styleUrls: ['./dashboard-refresh-timer.component.scss']
})
export class DashboardRefreshTimerComponent implements OnInit {

  @Input() title: string;

  timerInterval: any;
  dt: any;
  preObj: any;
  localTime: any;
  display: any;
  diffMilSec: any;
  timeOut: any;
  isRefreshTime: boolean = true;
  refreshDate: any;
  dateFrom: any;
  dateTo: any;
  isAutoRefreshDisabled: any;
  constructor(private appService: AppService) { }

  ngOnInit() {
  }

  /**
     * Showing Timer
     * @param last refresh date and time
     */
  startTimer(res) {
    this.timerInterval = setInterval(() => {
      this.dt = new Date(res.replace(/-/g, '/') + ' UTC');
      this.localTime = new Date();
      const distance: any = 1200000 - (this.localTime - this.dt);
      let minutes: any = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      let seconds: any = Math.floor((distance % (1000 * 60)) / 1000);
      minutes = (minutes === -1) ? 0 : minutes;
      seconds = (seconds === -1) ? 0 : seconds;
      minutes = (minutes < 10) ? '0' + minutes : minutes;
      seconds = (seconds < 10) ? '0' + seconds : seconds;
      this.display = minutes + ':' + seconds + ' Min ';
      if (distance < 0) {
        clearInterval(this.timerInterval);
      }
    }, 1000);
  }

  /**
  * Determines last data refresh inforamtion
  * @param updated timezone & abbreviation
  */
  setLastDataRefresh(res, m) {
    clearTimeout(this.timerInterval);
    this.dt = new Date(res.replace(/-/g, '/') + ' UTC');
    this.localTime = new Date();
    const diffMilSec = 1200000 - (this.localTime - this.dt);
    const diffMins = this.diffMilSec / 60000;
    if (m) {
      if (m.abbr === undefined) {
        const timezone = (new Date(res.replace(/-/g, '/') + ' UTC')).toTimeString();
        const result = timezone.match(/\((.*)\)/);
        const matches = result[1].match(/\b(\w)/g); // ['J','S','O','N']
        m.abbr = matches.join(''); // JSON
      }
      this.refreshDate = (m.updatedTimeZone) ?
        (new Date(res.replace(/-/g, '/') + ' UTC')).toLocaleString('en-US', { timeZone: m.updatedTimeZone }) + ' ' + m.abbr :
        (new Date(res.replace(/-/g, '/') + ' UTC')).toLocaleString() + ' ' + m.abbr;
      this.isRefreshTime = false;
      this.startTimer(res);
      if (m.auto_refresh) {
        this.timeOut = setTimeout(() => {
          this.onRefresh();
        }, diffMilSec);
      } else {
        clearTimeout(this.timerInterval);
        this.display = '';
      }
    }
  }

  /**
     * refresh data
     * @param event
     */
  onRefresh() {
    this.isRefreshTime = true;
    // this.onFilterSelection(this.cloneDataParam);
  }

  /**
     * Determines what to do on filter selection, sets fetched dates. changes loader status
     * @param combinedData
     */
  /* onFilterSelection(combinedData) {
    this.cloneDataParam = combinedData;
    this.isRefreshTime = true;
    this.isChartPlotted['key'] = false;
    if (combinedData.selectedDate) {
      this.selectedApi = combinedData.selectedApi;
      this.selectedServiceType = combinedData.selectedServiceType;
      this.selectedRegion = combinedData.selectedRegion;
      this.dateFrom = this.formateDate(combinedData.selectedDate.date[0]);
      if (combinedData.selectedDate.date[1] != null) {
        this.dateTo = this.formateDate(combinedData.selectedDate.date[1]);
      } else {
        this.dateTo = this.formateDate(combinedData.selectedDate.date[0]);
      }

      this.getStatusDetails(combinedData);
    } else {
      this.changeLoaderStatus(false);
      this.apiList = [];
      this.responseBackupData = [];
      this.sipUpdatedData = [];
      this.attestationUpdatedData = [];
    }
    this.dataService.getDateList().subscribe(
      (response) => {
        const res = response[0]['update_time'];
        this.rawRefreshTimeResponse = response[0]['update_time'];
        this.setLastDataRefresh(res, this.preObj);
      }, (error) => {
      });
  } */

}
